module.exports = __webpack_public_path__ + "img/white09_128.cf9e9c42.png";